import apiBaseState from "~/constants/apiBaseState";

const getState = () => {
    return {
        notificationsLoaded: false, // State for fetching notifications
        getNotificationsState: apiBaseState(), // State for fetching notifications
        updateNotificationState: apiBaseState(), // State for updating a notification
        deleteNotificationState: apiBaseState(), // State for deleting a notification
        bulkActionNotificationState: apiBaseState(), // State for deleting a notification
        notificationCount: 0,
        pusherNotifications: [],
        loadingMoreNotifications: false,
        updatingNotificationId: null
    };
};

export const state = () => (getState());

const transformPusherNotificationType = (payload) => {
    return {
        "pushed": true,
        "id": payload.id,
        "read_at": null,
        "emailed_at": payload.created_at,
        "data": {
            "title": payload.title,
            "created_at": payload.created_at,
            "message_id": payload.message_id,
            "text": payload.text,
            "model_id": payload.model_id,
            "model_type": payload.model_type,
            "url": payload.url,
            "type": payload.type,
            "immediate": null,
            "task": payload.task
        }
    };
};
export const mutations = {
    RESET_STORE(state) {
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    PUSHER_NOTIFICATION(state, payload) {
        const notification = transformPusherNotificationType(payload);
        state.pusherNotifications.unshift(notification);
    },
    SET_NOTIFICATIONS_LOADED(state) {
        state.notificationsLoaded = true;
    },
    RESET_PUSHER_NOTIFICATIONS(state, payload) {
        state.pusherNotifications = [];
    },
    SET_NOTIFICATIONS(state, payload) {
        state.pusherNotifications = [];
        state.getNotificationsState = payload;
    },
    SET_NOTIFICATIONS_DATA(state, payload) {
        state.getNotificationsState.data = payload;
    },
    UPDATE_NOTIFICATION_BY_ID(state, notification) {
        const newData = notification.data ? notification : transformPusherNotificationType(notification);

        const matchedIndex = state.getNotificationsState.data.data.findIndex(item =>
            item.data.model_id === notification.data.model_id &&
            item.data.model_type === notification.data.model_type);
        if(matchedIndex > -1){
            state.getNotificationsState.data.data.splice(matchedIndex, 1, newData);
        }
        const matchedPusherIndex = state.pusherNotifications.findIndex(item =>
            item.data.model_id === notification.data.model_id &&
            item.data.model_type === notification.data.model_type);
        if(matchedPusherIndex > -1){
            state.pusherNotifications.splice(matchedPusherIndex, 1, newData);
        }
    },
    DELETE_NOTIFICATION_BY_ID(state, notification) {
        const matchedIndex = state.getNotificationsState.data.data.findIndex(item =>
            item.data.model_id === notification.data.model_id &&
            item.data.model_type === notification.data.model_type);
        if(matchedIndex > -1){
            state.getNotificationsState.data.data.splice(matchedIndex, 1);
        }
    },
    SET_NOTIFICATIONS_LOADING_MORE_STATE(state, payload) {
        state.loadingMoreNotifications = payload;
    },
    SET_BULK_ACTION_NOTIFICATION(state, payload) {
        state.bulkActionNotificationState = payload;
    },
    SET_NOTIFICATIONS_MANUALLY(state, payload) {
        if(!state.getNotificationsState.data){
            return;
        }
        state.getNotificationsState.data.meta = payload.meta;
        state.getNotificationsState.data.data.push(...payload.data);
        state.loadingMoreNotifications = false;
    },
    PUSH_NOTIFICATIONS(state, payload) {
        if(!state.getNotificationsState.data){
           return;
        }
        state.getNotificationsState.data.data.push(...payload);
    },
    SET_UPDATE_NOTIFICATION(state, payload) {
        state.updateNotificationState = payload;
    },
    SET_DELETE_NOTIFICATION(state, payload) {
        state.deleteNotificationState = payload;
    },
    ADD_TO_NOTIFICATION_COUNT(state, payload){
      state.notificationCount++;
    },
    SET_NOTIFICATION_COUNT(state, payload){
        state.notificationCount = payload;
    },
    SET_NOTIFICATION_UPDATING_ID(state, payload){
        state.updatingNotificationId = payload;
    }
};

export const actions = {
    INITIALISE_PUSHER_LISTENER({ state, commit, rootState }, echo) {
        if (!rootState.auth.user) return;
        const channel = `App.User.${rootState.auth.user.id}`;
        echo.private(channel).notification((notification) => {
            const matchedIndex = state.getNotificationsState.data.data.findIndex(item => item.data.model_id === notification.model_id && item.data.model_type === notification.model_type);
            const matchedPusherIndex = state.pusherNotifications.findIndex(item => item.data.model_id === notification.model_id && item.data.model_type === notification.model_type);
            if(matchedIndex > -1 || matchedPusherIndex > -1){
                // need to transform notificatin here first...
                commit('UPDATE_NOTIFICATION_BY_ID', transformPusherNotificationType(notification));
            }else{
                commit('ADD_TO_NOTIFICATION_COUNT');
                commit('PUSHER_NOTIFICATION', notification);
            }
        });
    },
    async GET_NOTIFICATIONS({ commit, state }, {loadMore, ...params}) {
        const url = `/user/notifications`;
        commit('SET_NOTIFICATIONS_LOADED');
        if(loadMore){
            commit('SET_NOTIFICATIONS_LOADING_MORE_STATE', true);
            params.page = (state.getNotificationsState.data?.meta.current_page + 1 ) || 1;
        }
        const whyApiResponse = await this.$whyApi.get({
            url,
            params,
            pauseMutations: loadMore,
            mutation: "notifications/SET_NOTIFICATIONS",
            errorMessage: "Error getting notifications",
            notify: this.$notify
        });
        if(loadMore){
            commit('SET_NOTIFICATIONS_MANUALLY', whyApiResponse.data);
        }
        return whyApiResponse;
    },
    async UPDATE_NOTIFICATION({ commit, state }, payload) {
        commit('SET_NOTIFICATION_UPDATING_ID', payload.id);
        const url = `/user/notifications/${payload.id}`;
        const response = await this.$whyApi.put({
            url,
            mutation: "notifications/SET_UPDATE_NOTIFICATION",
            errorMessage: "Error updating notification",
            notify: this.$notify
        });
        commit('SET_NOTIFICATION_UPDATING_ID', null);
        commit('SET_NOTIFICATION_COUNT', state.notificationCount - 1);
        return response;
    },
    async DELETE_NOTIFICATION({ commit, state }, payload) {
        commit('SET_NOTIFICATION_UPDATING_ID', payload.id);
        const url = `/user/notifications/${payload.id}`;
        const response = await this.$whyApi.delete({
            url,
            mutation: "notifications/SET_DELETE_NOTIFICATION",
            errorMessage: "Error deleting notification",
            notify: this.$notify
        });
        commit('SET_NOTIFICATION_UPDATING_ID', null);
        if(!payload.read_at){
            commit('SET_NOTIFICATION_COUNT', state.notificationCount - 1);
        }

        return response;
    },
    async BULK_ACTION_NOTIFICATION({ commit, state }, data) {
        const {id, selectedAll, ...payload} = data;
        if(!selectedAll){
            commit('SET_NOTIFICATION_UPDATING_ID', id);
        }
        commit('RESET_PUSHER_NOTIFICATIONS');
        const url = `/user/notifications/bulk-action`;
        const response = await this.$whyApi.post({
            url,
            mutation: "notifications/SET_BULK_ACTION_NOTIFICATION",
            errorMessage: "Error updating notification",
            data: payload,
            notify: this.$notify
        });
        if(!selectedAll){
            commit('SET_NOTIFICATION_UPDATING_ID', null);
        }
        if(payload.action === 'markAsUnread'){
            commit('SET_NOTIFICATION_COUNT', state.notificationCount + 1);
        }
        if(payload.action === 'markAsRead' && selectedAll){
            commit('SET_NOTIFICATION_COUNT', 0);
        }
        return response;
    }
};
